module.exports = __webpack_public_path__ + "img/CGDT-6000.0488df86.png";